import { Component, OnInit } from '@angular/core';
import { states as allStates } from 'src/app/constants/states';
import { delhiStateSVG } from 'src/app/constants/svgs/delhi-state';
import { gujaratStateSVG } from 'src/app/constants/svgs/gujarat-state';
import { haryanaStateSVG } from 'src/app/constants/svgs/haryana-state';
import { maharashtraStateSVG } from 'src/app/constants/svgs/maharashtra-state';

@Component({
  selector: 'app-state-section',
  templateUrl: './state-section.component.html',
  styleUrls: ['./state-section.component.scss'],
})
export class StateSectionComponent implements OnInit {
  states!: typeof allStates;
  delhiStateSVG = delhiStateSVG;
  gujaratStateSVG = gujaratStateSVG;
  haryanaStateSVG = haryanaStateSVG;
  maharashtraStateSVG = maharashtraStateSVG;
  private toShowStateIds = ['2', '10', '20', '30'];

  constructor() {}

  ngOnInit() {
    this.filterStates();
  }

  private filterStates() {
    this.states = allStates.filter((state) =>
      this.toShowStateIds.includes(state.stateId)
    );
  }
}
